export default {
  path: '/action_types',
  name: 'action_types',
  component: () => import('../components/actiontype/Layout'),
  redirect: { name: 'ActiontypeList' },
  meta: {
    breadcrumb: 'ticket.actiontypes',
  },
  children: [
    {
      name: 'ActiontypeList',
      path: '',
      component: () => import('../views/actiontype/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ActiontypeCreate',
      path: 'new',
      component: () => import('../views/actiontype/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ActiontypeUpdate',
      path: ':id/edit',
      component: () => import('../views/actiontype/Update'),
      meta: {
        breadcrumb: 'ticket.actiontype',
      },
    },
    {
      name: 'ActiontypeShow',
      path: ':id',
      component: () => import('../views/actiontype/Show'),
      meta: {
        breadcrumb: 'ticket.actiontype',
      },
    }
  ]
};
